export enum ReserveErrorsMessages {
  ENTITY_DATA_ERROR = '[reserve] cannot retrieve entity data',
}

/**
 * @todo change default message
 */
export class ReserveError extends Error {
  constructor(message = ReserveErrorsMessages.ENTITY_DATA_ERROR) {
    super(message);
  }
}



// WEBPACK FOOTER //
// ./src/shared/errors/reserve.error.ts